export var ARISE_DOMAIN_REFG = /\/\/img\.mrvcdn\.com/i;
export var ARISE_DOMAIN = '//img.mrvcdn.com/';
export var FILE_EXTENSION_EXCLUDE_RESIZE_REG = /\.svg/i;
export var GW_CDN_DOMAIN = 'gw.alicdn.com';
export var IMG_ALICDN_DOMAIN = 'img.alicdn.com';
export var FB_ES_DOMAIN = 'fb-es.mrvcdn.com';
export var GCP_OSS_DOMAIN = 'arise-gcp-oss.oss-eu-central-1.aliyuncs.com';
export var LONG_OSS_DOMAIN = 'arise-longimage.oss-eu-central-1.aliyuncs.com';
export var RESIZE_SUFFIX_REG = /_((\d+)?x(\d+)?)?([qQ]\d{2,3}?)?(s\d{3})?\.(jpg|jpeg|png|gif|webp)(_\.webp)?$/;
export var WEBP_SUFFIX_REG = /_\.webp/;
export var SVG_SUFFIX_REG = /\.gif$/;
export var DUPLICATED_SUFFIX_REG = /(jpg|jpeg|png|gif|webp)\.(jpg|jpeg|png|gif|webp)/i;
export var FILE_EXT_REG = /\.(jpg|jpeg|png|gif|webp|bmp|tiff|cnt)/i;
export var AE_CDN_DOMAIN_REG = /ae(01|02|03|04)\.alicdn\.com/i;
export var SG_LIVE_CDN_REG = /sg-live(-[0-9]{2})?.slatic.net/i;
export var LZD_CDN_DOMAIN = 'lzd-u.slatic.net';
export var LZD_MY_CDN_DOMAIN_REG = /my-(test|live)(-[0-9]{2})?.slatic.net/i;
export var LZD_UGC_ACCELERATE_OSS_DOMAIN = 'lazada-user-upload.oss-accelerate.aliyuncs.com';
export var LZD_UGC_OSS_DOMAIN = 'lazada-user-upload.oss-ap-southeast-1.aliyuncs.com';